/* eslint-disable react/jsx-no-useless-fragment */
import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { NonShippingDays } from './components/NonShippingDays';
import { ProcessingTime } from './components/ProcessingTime';
import { ShippingMethod } from './components/ShippingMethod';
import { Submitted } from './components/Submitted';
import { LiveDate } from './components/LiveDate';
import {
  PROCESSING_TIME_FORM_NAME,
  WORKING_DAYS_FORM_NAME, CARRIER_FORM_NAME, SERVICE_FORM_NAME,
  LIVE_DATE_FORM_NAME, NON_SHIPPING_DAYS_FORM_NAME,
} from './constants';
import { WorkingDays } from './components/WorkingDays';
import { DataChecking } from './components/DataChecking';
import { EddOnboardingOptions } from './api/types';
import useConnectionContext from '../../hooks/useConnectionContext';
import useApplicationContext from '../../hooks/useApplicationContext';

const EddApplication = () => {
  const [form] = Form.useForm<FormInstance>();
  const [onboardingOptions, setOnboardingOptions] = useState<EddOnboardingOptions>();
  const { merchantId } = useConnectionContext();
  const { data, isLoading: isEddLoading } = useApplicationContext();

  useEffect(() => {
    if (!isEddLoading) {
      setOnboardingOptions(data.EDD);
    }
  }, [isEddLoading]);

  return (
    <>
      {onboardingOptions && (
        <Form name="enable_edd" form={form}>
          <Form.Item name={PROCESSING_TIME_FORM_NAME} noStyle></Form.Item>
          <Form.Item name={WORKING_DAYS_FORM_NAME} noStyle></Form.Item>
          <Form.Item name={CARRIER_FORM_NAME} noStyle></Form.Item>
          <Form.Item name={NON_SHIPPING_DAYS_FORM_NAME} noStyle></Form.Item>
          <Form.Item name={SERVICE_FORM_NAME} noStyle></Form.Item>
          <Form.Item name={LIVE_DATE_FORM_NAME} noStyle></Form.Item>
          <Routes>
            <Route path="/processing-time" element={<ProcessingTime timeOptions={onboardingOptions.processingTimeList} />} />
            <Route path="/working-days" element={<WorkingDays />} />
            <Route path="/nonshipping-days" element={<NonShippingDays />} />
            <Route
              path="/shipping-method"
              element={(
                <ShippingMethod
                  methodOptions={onboardingOptions.carrier2ServiceList}
                />
              )}
            />
            <Route path="/live-date" element={<LiveDate merchantId={merchantId} />} />
            <Route path="/data-checking" element={<DataChecking />} />
            <Route path="/submitted" element={<Submitted />} />
          </Routes>
        </Form>
      )}
    </>

  );
};
export { EddApplication };
